import { useState } from 'react';

// NsPage: form-page — standalone login-flow form, its inputs are real form
// fields (new/confirm password), not filter/toolbar controls.
export default function ResetPassword() {
  const cfg     = JSON.parse(sessionStorage.getItem('tenantConfig') || '{}');
  const name    = cfg.companyName  || 'Portal';
  const primary = cfg.primaryColor || '#062722'; // hex-ok — tenant primaryColor fallback, no matching semantic var

  const token = window.location.pathname.split('/auth/reset-password/')[1]?.trim() ?? '';

  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [status,   setStatus]   = useState('idle');
  const [error,    setError]    = useState('');

  if (!token) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--color-bg-primary)' }}>
        <div style={{ textAlign: 'center', padding: '2.5rem', background: 'var(--color-bg-secondary)', borderRadius: '0.75rem', maxWidth: '360px', width: '100%', border: '1px solid var(--color-border)' }}>
          <div style={{ fontWeight: 600, fontSize: '1.6rem', color: primary, marginBottom: '1rem' }}>{name}</div>
          <p style={{ color: 'var(--color-danger)' }}>Invalid reset link.</p>
          <a href="/" style={{ color: primary, fontSize: '0.8125rem', textDecoration: 'none' }}>← Back to sign in</a>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setStatus('saving'); setError('');
    try {
      const res  = await fetch('/api/roch-auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error ?? 'Reset failed.'); setStatus('error'); }
      else setStatus('done');
    } catch { setError('Network error. Please try again.'); setStatus('error'); }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--color-bg-primary)' }}>
      <div style={{ textAlign: 'center', padding: '2.5rem', background: 'var(--color-bg-secondary)', borderRadius: '0.75rem', boxShadow: '0 4px 24px rgba(6,39,34,0.12)', maxWidth: '360px', width: '100%', border: '1px solid var(--color-border)' }}>
        <div style={{ fontWeight: 600, fontSize: '1.6rem', color: primary, marginBottom: '0.25rem' }}>{name}</div>
        <div style={{ fontSize: '0.875rem', color: 'var(--color-text-label)', marginBottom: '1.75rem' }}>Set a new password</div>

        {status === 'done' ? (
          <>
            <p style={{ color: 'var(--color-success-text)', background: 'var(--color-success-bg)', padding: '0.75rem', borderRadius: '0.375rem', fontSize: '0.875rem', margin: '0 0 1.25rem' }}>
              Password updated. You can now sign in.
            </p>
            <a href="/" style={{ color: primary, fontSize: '0.875rem', fontWeight: 600, textDecoration: 'none' }}>Sign in →</a>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="New password (min 8 chars)" autoComplete="new-password" required autoFocus
              style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid var(--color-border)', borderRadius: '0.375rem', fontSize: '0.9rem', marginBottom: '0.625rem', boxSizing: 'border-box' }}
            />
            <input
              type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
              placeholder="Confirm new password" autoComplete="new-password" required
              style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid var(--color-border)', borderRadius: '0.375rem', fontSize: '0.9rem', marginBottom: '0.75rem', boxSizing: 'border-box' }}
            />
            {error && <p style={{ color: 'var(--color-danger)', fontSize: '0.8rem', margin: '0 0 0.5rem' }}>{error}</p>}
            <button type="submit" disabled={status === 'saving'}
              style={{ padding: '0.625rem 1.5rem', background: primary, color: 'var(--color-accent-btn-text)', border: 'none', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 600, cursor: 'pointer', width: '100%', opacity: status === 'saving' ? 0.7 : 1 }}>
              {status === 'saving' ? 'Saving…' : 'Set Password'}
            </button>
          </form>
        )}

        <a href="/" style={{ display: 'block', marginTop: '1.25rem', color: 'var(--color-text-muted)', fontSize: '0.8125rem', textDecoration: 'none' }}>← Back to sign in</a>
      </div>
    </div>
  );
}
